import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./routes/ProtectedRoute";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { meThunk } from "./features/auth/authSlice";

import LoginPage from "./pages/LoginPage";
import AppLayout from "./layouts/AppLayout";

import DashboardPage from "./pages/DashboardPage";
import StatesPage from "./pages/StatesPage";
import RegionsPage from "./pages/RegionsPage";
import CountiesPage from "./pages/CountiesPage";
import AuctionRuleTemplatesPage from "./pages/AuctionRuleTemplatesPage";
import AuctionsPage from "./pages/AuctionsPage";
import AuctionPropertiesPage from "./pages/AuctionPropertiesPage";
import AuctionPropertyResearchPage from "./pages/AuctionPropertyResearchPage";
import QuickSearchPage from "./pages/QuickSearchPage";

function AppBoot() {
  const dispatch = useDispatch();
  const { user } = useSelector((s) => s.auth);

  useEffect(() => {
    if (!user) dispatch(meThunk());
  }, [user, dispatch]);

  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <AppBoot />
      <Routes>
        <Route path="/" element={<Navigate to="/app/dashboard" replace />} />

        {/* Desprotegida */}
        <Route path="/login" element={<LoginPage />} />

        {/* Protegidas */}
        <Route element={<ProtectedRoute />}>
          <Route path="/app" element={<AppLayout />}>
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="states" element={<StatesPage />} />
            <Route path="regions" element={<RegionsPage />} />
            <Route path="counties" element={<CountiesPage />} />
            <Route path="rules" element={<AuctionRuleTemplatesPage />} />
            <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="auctions" element={<AuctionsPage />} />
            <Route path="quick-search" element={<QuickSearchPage />} />
            <Route
              path="auctions/:auctionId/properties"
              element={<AuctionPropertiesPage />}
            />
            <Route
              path="auctions/:auctionId/properties/:propertyId/research"
              element={<AuctionPropertyResearchPage />}
            />
          </Route>
        </Route>

        <Route path="*" element={<Navigate to="/app/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
